(function() {
  'use strict';

  angular
    .module('ykwx', [
    	// Generated modules
        'ngAnimate', 
    	'ngCookies', 
    	'ngSanitize', 
    	'ngResource', 
    	'ngRoute', 
        'ngCachedResource',
        'ui.router',
        // Pagination
        'infinite-scroll',
        // Smooth scroll
        'duScroll',
        // Addthis for angular
        'sn.addthis',
        // Loading bar
        'angular-loading-bar',
        'angular-storage',
        'truncate',
        // Page titles & Meta data
        'viewhead',
        'ng-showdown',
        'slickCarousel',
        'contentful',
        'angular-google-analytics',
        'ngMaterial'
    ]);

})();

angular.module('ykwx')

	.controller('StaticPagesHomeController', function($scope, $rootScope, $stateParams, contentful, $filter) {

		$scope.loading = true;

		// Fetch entries from API
    	contentful
      		.entries('content_type=homePage&order=-sys.createdAt&limit=1')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entries = response.data.items[0].fields;
		          	console.log($scope.entries);
					$scope.loading = false;
		        }
	      	);

		// Meta data
		$rootScope.pageTitle = "Home";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "home";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesAboutController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'about';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
    		.entry('1ggIRn4EG882QSq2SAkcse')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.fields;
		          	if ($scope.entry.featuredImage) {
			          	var imageId = $scope.entry.featuredImage.sys.id;
			          	contentful
				      		.asset(imageId)
				      		.then(
						        // Success handler
						        function(response){
						          	$scope.featuredImage = response.data.fields.file.url;
						          	$scope.loading = false;
						        }
					      	);
		          	} else {
		          		$scope.loading = false;
		          	}
		        }
	      	);



		// Meta data
		$rootScope.pageTitle = "About";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "about";
		$rootScope.pageImage = "";

	})


	.controller('StaticPagesContactController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'contact';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
    		.entry('2npvA6lAdqcgIceaQaSqoE')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.fields;
		          	if ($scope.entry.featuredImage) {
			          	var imageId = $scope.entry.featuredImage.sys.id;
			          	contentful
				      		.asset(imageId)
				      		.then(
						        // Success handler
						        function(response){
						          	$scope.featuredImage = response.data.fields.file.url;
						          	$scope.loading = false;
						        }
					      	);
		          	} else {
		          		$scope.loading = false;
		          	}
		        }
	      	);


		// Meta data
		$rootScope.pageTitle = "Contact";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "contact";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesContributorsController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'contact';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
    		.entry('w09dmM7xlu8MooGKsUOey')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.fields;
		          	if ($scope.entry.featuredImage) {
			          	var imageId = $scope.entry.featuredImage.sys.id;
			          	contentful
				      		.asset(imageId)
				      		.then(
						        // Success handler
						        function(response){
						          	$scope.featuredImage = response.data.fields.file.url;
						          	$scope.loading = false;
						        }
					      	);
		          	} else {
		          		$scope.loading = false;
		          	}

		        }
	      	);


		// Meta data
		$rootScope.pageTitle = "Contact";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "contact";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesAdvertisersController', function($scope, $rootScope, $stateParams, contentful) {

		$scope.page = 'contact';
		$scope.loading = true;

      	// Fetch entries from API
    	contentful
    		.entry('4vlYqkn6sMI4iIw0i42mGO')
      		.then(
		        // Success handler
		        function(response){
		          	$scope.entry = response.data.fields;
		          	if ($scope.entry.featuredImage) {
			          	var imageId = $scope.entry.featuredImage.sys.id;
			          	contentful
				      		.asset(imageId)
				      		.then(
						        // Success handler
						        function(response){
						          	$scope.featuredImage = response.data.fields.file.url;
						          	$scope.loading = false;
						        }
					      	);
		          	} else {
		          		$scope.loading = false;
		          	}
		        }
	      	);


		// Meta data
		$rootScope.pageTitle = "Contact";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "contact";
		$rootScope.pageImage = "";

	})

	.controller('StaticPagesNewsletterController', function($scope, $rootScope, $stateParams) {

		// Meta data
		$rootScope.pageTitle = "Newsletter";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "newsletter";
		$rootScope.pageImage = "";

	})

	;
angular.module('ykwx')

	.controller('EntriesController', function($document, $scope, $rootScope, $stateParams, contentful) {

		$scope.loading = true;
		$scope.page = 'journal';

		$scope.entries = [];
        $scope.fetchedItems = 0;
        $scope.totalItems = 0;

        $scope.limit = 5;
        $scope.skip = 0;
        $scope.ready = false;


		// Fetch entries from API
		$scope.addMoreItems = function() {
            // Reset scroll
            $scope.ready = false;
            if ( $scope.totalItems >= $scope.fetchedItems ) {
		    	contentful
				.entries('content_type=article&order=-fields.date&limit=' + $scope.limit + '&skip=' + $scope.skip)
		      		.then(
				        // Success handler
				        function(response){

				          	angular.forEach(response.data.items, function (e) {
		                        $scope.entries.push(e);
		                    });
							console.log($scope.entries);

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);
			};
		};

		// Meta data
		$rootScope.pageTitle = "Journal";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "journal";
		$rootScope.pageImage = "";

	})


	.controller('EntriesShowController', function($scope, $rootScope, $stateParams, contentful, $timeout, $mdDialog) {

		$scope.entryId = $stateParams.slug;

		$scope.loading = true;
		$scope.page = 'journal';
		$scope.template = $stateParams.type;

		// Fetch entries from API
		contentful
			.entries('content_type=article&fields.slug=' + $stateParams.slug)
			.then(
				// Success handler
				function(response){
					$scope.entry = response.data.items[0].fields;
					$timeout(function (){
						$scope.loading = false;
					}, 1000);

					console.log($scope.entry);
					// Meta data
					$rootScope.pageTitle = $scope.entry.title;
					$rootScope.pageDescription = $scope.entry.excerpt;
					$rootScope.pageUrl = "journal/" + $scope.template + "/" + $scope.entry.slug;
					$rootScope.pageImage = "https:" + $scope.entry.heroImages[0].fields.file.url;
				}
			);




		$rootScope.imageModal = function(s, images) {

            $mdDialog.show({
				clickOutsideToClose: true,
				templateUrl: 'templates/views/shared/image-modal.html',
				locals: { s: s, images: images },
				controller: ['$scope', 's', 'images', function($scope, s, images) {
					$scope.imageUrl = s;
                    $scope.allImages = images;
				}]
			});
		};



	})

	.controller('EntriesEventsController', function($document, $scope, $rootScope, $stateParams, contentful) {

		$scope.loading = true;
		$scope.page = 'events';

		$scope.entries = [];
        $scope.fetchedItems = 0;
        $scope.totalItems = 0;

        $scope.limit = 5;
        $scope.skip = 0;
        $scope.ready = false;


		// Fetch entries from API
		$scope.addMoreItems = function() {
            // Reset scroll
            $scope.ready = false;

            if ( $scope.totalItems >= $scope.fetchedItems ) {
		    	contentful
		      		.entries('content_type=event&order=fields.startDate&limit=' + $scope.limit + '&skip=' + $scope.skip)
		      		.then(
				        // Success handler
				        function(response){

				          	angular.forEach(response.data.items, function (e) {
		                        $scope.entries.push(e);
		                    });

		                    $scope.skip = $scope.skip + $scope.limit;
		                    $scope.totalItems = response.data.total;
		                    $scope.fetchedItems = $scope.entries.length;

		                    // Fire scroll
		                    $scope.ready = true;
							$scope.loading = false;
				        }
			      	);
			};
		};

		// Meta data
		$rootScope.pageTitle = "Events";
		$rootScope.pageDescription = "";
		$rootScope.pageUrl = "events";
		$rootScope.pageImage = "";

	})


	;

angular.module('ykwx')
  	
	.controller('AppController', function($scope, $rootScope, $document, $window, $timeout, $location, $stateParams, $state, $mdSidenav, $mdDialog) {
		
		// Current year
		$scope.year = new Date().getFullYear();
		
		// Scroll to top of page when hitting up arrow
		$scope.topScroll = function(e) {
			$document.scrollTopAnimated(0, 1000);
		};

	    // Scroll to top on page load
		$scope.$on('$viewContentLoaded', function(){
			$document.scrollTopAnimated(0, 100);
		});


	    $scope.openMenu = function($mdOpenMenu, ev) {
	    	originatorEv = ev;
	   		$mdOpenMenu(ev);
	    };
		
	    $scope.closeMenu = function($mdCloseMenu, ev) {
	    	originatorEv = ev;
	   		$mdCloseMenu(ev);
	    };

	    // Navigation side menu
	    $scope.toggleLeft = buildToggler('left');
		
		function buildToggler(navID) {
			return function() {
				$mdSidenav(navID)
					.toggle()
					.then(function () {
				});
			}
		}


		$scope.close = function () {
			$mdSidenav('left').close();
		};


		$scope.showNewsletter = function($event, s) {
			$mdDialog.show({
				clickOutsideToClose: true,
				templateUrl: 'templates/views/shared/newsletter-signup.html',
				scope: $scope,
				preserveScope: true,
				targetEvent: $event
			});
		};

	});

(function() {
  'use strict';

  angular
    .module('ykwx');
    
})();

(function() {
  'use strict';

  angular
    .module('ykwx')
    
    // Trusted hosts [ie, a url from youtube, vimeo hosted files etc]
    .filter('trustUrl', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    })

    // Trust embed 
    .filter('trustEmbed', function ($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    })

    // Capitalise text
    .filter('capitalize', function() {
        return function(input, all) {
            return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
        };
    })

    // Replace hyphens with space
    .filter('space', function() {
        return function(str) {
            return str.replace(/-/g, ' ');
        };
    })


    // Chop text string if longer than defined length
    .filter('strLimit', ['$filter', function($filter) {
        return function(input, limit) {
            if (! input) return;
            if (input.length <= limit) {
                return input;
            }
            return $filter('limitTo')(input, limit) + '...';
        };

    }])



    ;

})();



(function() {
  'use strict';

  angular
    .module('ykwx')
    .config(routeConfig)

	.config(function ($sceDelegateProvider, contentfulProvider, AnalyticsProvider) {

	    // Trust these urls
	    $sceDelegateProvider.resourceUrlWhitelist([
     		'self',
     		'*://www.youtube.com/**',
     		'*://www.vimeo.com/**',
     		'*://www.shopify.com/**',
        '*://www.mixcloud.com/**'
   		])

      // Contentful API
      contentfulProvider.setOptions({
        space: 'dyigp9c9874k',
        accessToken: 'd634a01d8d6eda839b60ed529e8aa2820e581e03e102295043548fd2a6409422'
      });


      // Google analytics
      AnalyticsProvider.setAccount('UA-127723709-1');

	})


  .run(function(Analytics) { })


  function routeConfig($stateProvider, $locationProvider) {

    $locationProvider.html5Mode(true);
    // $locationProvider.hashPrefix('!');


    // Routes for the site
    $stateProvider

      .state('home', {
        url: '/',
        templateUrl: 'templates/views/static_pages/home.html',
        controller: 'StaticPagesHomeController'
      })

      .state('about', {
        url: '/about',
        templateUrl: 'templates/views/static_pages/page.html',
        controller: 'StaticPagesAboutController'
      })

      .state('contact', {
        url: '/contact',
        templateUrl: 'templates/views/static_pages/page.html',
        controller: 'StaticPagesContactController'
      })

      .state('contributors', {
        url: '/contributors',
        templateUrl: 'templates/views/static_pages/page.html',
        controller: 'StaticPagesContributorsController'
      })

      .state('advertisers', {
        url: '/advertisers',
        templateUrl: 'templates/views/static_pages/page.html',
        controller: 'StaticPagesAdvertisersController'
      })

      .state('newsletter', {
        url: '/newsletter',
        templateUrl: 'templates/views/static_pages/newsletter.html',
        controller: 'StaticPagesNewsletterController'
      })

      .state('entries', {
        url: '/journal',
        templateUrl: 'templates/views/entries/index.html',
        controller: 'EntriesController'
      })

      .state('entry', {
        url: '/journal/:type/:slug',
        templateUrl: 'templates/views/entries/show.html',
        controller: 'EntriesShowController'
      })

      .state('events', {
        url: '/events',
        templateUrl: 'templates/views/entries/events.html',
        controller: 'EntriesEventsController'
      })



      ;
  }



})();

(function() {
  'use strict';

  angular
    .module('ykwx')

    .directive('leftCol', function leftCol() {
        var leftCol = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/left-col.html'
        };
        return leftCol;
    })

    .directive('loading', function loading() {
        var loading = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/loading.html'
        };
        return loading;
    })

    .directive('mainLogo', function mainLogo() {
        var mainLogo = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/main-logo.html'
        };
        return mainLogo;
    })

    .directive('homePageNav', function homePageNav() {
        var homePageNav = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/homepage-nav.html'
        };
        return homePageNav;
    })

    .directive('newsletterSignup', function newsletterSignup() {
        var newsletterSignup = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/newsletter-signup.html'
        };
        return newsletterSignup;
    })

    .directive('social', function social() {
        var social = {
            restrict: 'E',
            templateUrl: 'templates/views/shared/social.html'
        };
        return social;
    })

    .directive('mdFooter', function footer() {
        var footer = {
          	restrict: 'E',
          	templateUrl: 'templates/views/shared/footer.html'
        };
        return footer;
    })


    // Smooth transition between pages
    .directive('smoothLoad', function ($window, $rootScope, $timeout) {
        return function() {

            $timeout(function () {
                $('.fade').fadeIn(400);
            }, 500);

        };
    })

    // Add target blank to all links in CMS rendered content
    .directive('linkAway', function ($timeout) {
        return function() {

            $timeout(function () {
                $('.contents a').attr('target', '_blank');
            }, 500);

        };
    })

    // Smooth transition between pages
    .directive('iframe', function ($window, $rootScope) {
        return function() {
            var newHeight = $('iframe').context.children[0].clientHeight;
            console.log(newHeight);
            $('iframe').height(newHeight);
        };
    })

    .directive('images', function ($window, $rootScope, $timeout) {
        return function() {
            $timeout(function () {
                $('.contents img').on('click', function () {
                    var img = $(this).attr('src');
                    $rootScope.imageModal(img);
                });
                $('.contents img').css('cursor', 'pointer').parent().addClass('wide');
            }, 500);

        };
    })


})();

angular.module("ykwx").run(["$templateCache", function($templateCache) {$templateCache.put("templates/views/entries/events.html","<left-col></left-col><div class=\"page\" id=\"events-page\" ng-init=\"addMoreItems()\"><loading></loading><div infinite-scroll=\"addMoreItems()\" infinite-scroll-disabled=\"!ready\" infinite-scroll-distance=\"2\" ng-if=\"!loading\"><section class=\"wrapper mid-wrapper\"><article class=\"block columns twelve\" id=\"hero-block\" ng-if=\"$first\" ng-repeat=\"e in entries | limitTo: 1\"><div class=\"block-img\"><a ng-href=\"{{::e.fields.linkToEvent}}\" target=\"_blank\"><img class=\"image\" ng-src=\"{{::e.fields.featuredImage.fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=720\"></a><div class=\"meta journal-post\"><h4><span class=\"follow-line\">Event</span></h4></div></div><div class=\"text\"><h4><span ng-bind-html=\"::e.fields.startDate | date: &#39;d MMMM yyyy&#39;\"></span><span ng-if=\"e.fields.endDate\">– {{::e.fields.endDate | date: &#39;d MMMM yyyy&#39;}}</span></h4><h2 ng-bind-html=\"::e.fields.title\"></h2><p ng-bind-html=\"::e.fields.excerpt\"></p></div><a class=\"btn\" ng-href=\"{{::e.fields.linkToEvent}}\" target=\"_blank\">Read more</a></article><div class=\"clearfix\"></div><article class=\"article-block block columns six\" ng-if=\"!$first\" ng-repeat=\"e in entries\"><div class=\"block-img\"><a ng-href=\"{{::e.fields.linkToEvent}}\" target=\"_blank\"><img class=\"image\" ng-src=\"{{::e.fields.featuredImage.fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=520\"></a><div class=\"meta journal-post\"><h4><span class=\"follow-line\">Event</span></h4></div></div><div class=\"text\"><h4><span ng-bind-html=\"::e.fields.startDate | date: &#39;d MMMM yyyy&#39;\"></span><span ng-if=\"e.fields.endDate\">– {{::e.fields.endDate | date: &#39;d MMMM yyyy&#39;}}</span></h4><h2 ng-bind-html=\"::e.fields.title\"></h2><p ng-bind-html=\"::e.fields.excerpt\"></p></div><a class=\"btn\" ng-href=\"{{::e.fields.linkToEvent}}\" target=\"_blank\">Read more</a></article></section></div></div><social></social><md-footer></md-footer>");
$templateCache.put("templates/views/entries/index.html","<left-col></left-col><div class=\"page\" ng-init=\"addMoreItems()\"><loading></loading><div infinite-scroll=\"addMoreItems()\" infinite-scroll-disabled=\"!ready\" infinite-scroll-distance=\"2\" ng-if=\"!loading\"><section class=\"wrapper lrg-wrapper\"><article class=\"block columns twelve\" id=\"hero-block\" ng-if=\"$first\" ng-repeat=\"e in entries | limitTo: 1\"><div class=\"block-img\"><a ng-href=\"/journal/article/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType != false\"><img class=\"image\" ng-src=\"{{::e.fields.heroImages[0].fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=800\"></a><a ng-href=\"/journal/gallery/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType == false\"><img class=\"image\" ng-src=\"{{::e.fields.heroImages[0].fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=800\"></a><div class=\"meta journal-post\"><h4><span class=\"follow-line\">Journal</span><span ng-bind-html=\"::e.fields.date | date: &#39;dd.MM.yy&#39;\"></span></h4></div></div><div class=\"text\"><h2 ng-bind-html=\"::e.fields.title\"></h2><p ng-bind-html=\"::e.fields.excerpt\"></p></div><a class=\"btn\" ng-href=\"/journal/article/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType != false\">Read more</a><a class=\"btn\" ng-href=\"/journal/gallery/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType == false\">Read more</a></article><div class=\"clearfix\"></div><article class=\"article-block block columns six\" ng-if=\"!$first\" ng-repeat=\"e in entries\"><div class=\"block-img\"><a ng-href=\"/journal/article/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType != false\"><img class=\"image\" ng-src=\"{{::e.fields.heroImages[0].fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=520\"></a><a ng-href=\"/journal/gallery/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType == false\"><img class=\"image\" ng-src=\"{{::e.fields.heroImages[0].fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=520\"></a><div class=\"meta journal-post\"><h4><span class=\"follow-line\">Journal</span><span ng-bind-html=\"::e.fields.date | date: &#39;dd.MM.yy&#39;\"></span></h4></div></div><div class=\"text\"><h2 ng-bind-html=\"::e.fields.title\"></h2><p ng-bind-html=\"::e.fields.excerpt\"></p></div><a class=\"btn\" ng-href=\"/journal/article/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType != false\">Read more</a><a class=\"btn\" ng-href=\"/journal/gallery/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType == false\">Read more</a></article></section></div></div><social></social><md-footer></md-footer>");
$templateCache.put("templates/views/entries/show.html","<left-col></left-col><div class=\"page\" id=\"journal-post\"><article class=\"wrapper\"><div id=\"gallery-article\" ng-if=\"template == &#39;gallery&#39;\"><div class=\"block\" link-away=\"\" ng-if=\"!loading\"><div class=\"mid-wrapper\" id=\"imageGallerySlider\"><slick adaptiveheight=\"true\" dots=\"true\" fade=\"true\" infinite=\"false\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide hero-slide\" style=\"background-image: url({{entry.heroImages[0].fields.file.url}})\"><div class=\"text\"><h1 class=\"tiny-wrapper\" ng-bind-html=\"entry.title\"></h1><div class=\"excerpt tiny-wrapper\" ng-bind-html=\"entry.standfirst\"></div></div></div><div class=\"slick-slide\" ng-repeat=\"i in entry.slides\"><img alt=\"{{i.fields.image.fields.title}}\" ng-if=\"i.fields.image\" ng-src=\"{{i.fields.image.fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=1200\"><video controls=\"true\" ng-if=\"i.fields.video\" ng-src=\"{{i.fields.video.fields.file.url}}\" playsinline=\"true\"></video><div class=\"text\" markdown-to-html=\"i.fields.textBlock\" ng-if=\"i.fields.textBlock\" style=\"background-color:{{i.fields.backgroundColour}}; color:{{i.fields.textColour}}\"></div></div></slick></div></div></div><div id=\"standard-article\" ng-if=\"template == &#39;article&#39;\"><div class=\"block\" link-away=\"\" ng-if=\"!loading\"><div class=\"small-wrapper\" id=\"imageGallerySlider\"><slick dots=\"true\" infinite=\"true\" slides-to-scroll=\"1\" slides-to-show=\"1\"><div class=\"slick-slide click\" ng-click=\"imageModal(i.fields.file.url, entry.heroImages)\" ng-repeat=\"i in entry.heroImages\"><img alt=\"{{i.fields.title}}\" ng-src=\"{{i.fields.file.url}}?fm=jpg&amp;fl=progressive&amp;w=1200\"></div></slick></div><div images=\"\"><h1 class=\"tiny-wrapper\" ng-bind-html=\"entry.title\"></h1><div class=\"excerpt tiny-wrapper\" ng-bind-html=\"entry.standfirst\"></div><div class=\"contents\" markdown-to-html=\"entry.body\"></div><div class=\"share center-text\"><div class=\"addthis_inline_share_toolbox\" data-share=\"share\" sn-addthis-toolbox=\"\"></div></div></div></div></div></article></div><social></social><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/home.html","<left-col></left-col><div class=\"page\"><loading></loading><div ng-if=\"!loading\"><section class=\"wrapper lrg-wrapper\"><article class=\"block columns twelve\" id=\"hero-block\"><div class=\"block-img\"><a ng-href=\"/journal/article/{{::entries.heroArticle.fields.slug}}\" ng-if=\"entries.heroArticle.fields.articleType != false\"><img class=\"image\" ng-src=\"{{::entries.heroArticle.fields.heroImages[0].fields.file.url}}\"></a><a ng-href=\"/journal/gallery/{{::entries.heroArticle.fields.slug}}\" ng-if=\"entries.heroArticle.fields.articleType == false\"><img class=\"image\" ng-src=\"{{::entries.heroArticle.fields.heroImages[0].fields.file.url}}\"></a><div class=\"meta journal-post\" ng-class=\"{&#39;getCloser&#39;: !entries.heroArticle.fields.date}\"><h4><span class=\"follow-line\">Journal</span><span ng-bind-html=\"::entries.heroArticle.fields.date | date: &#39;dd.MM.yy&#39;\"></span></h4></div></div><div class=\"text\"><h2 ng-bind-html=\"::entries.heroArticle.fields.title\"></h2><p ng-bind-html=\"::entries.heroArticle.fields.excerpt\"></p></div><a class=\"btn\" ng-href=\"/journal/article/{{::entries.heroArticle.fields.slug}}\" ng-if=\"e.fields.articleType != false\">Read more</a><a class=\"btn\" ng-href=\"/journal/gallery/{{::entries.heroArticle.fields.slug}}\" ng-if=\"e.fields.articleType == false\">Read more</a></article><div class=\"clearfix\"></div><article class=\"article-block block columns six\" ng-repeat=\"e in entries.articles\"><div class=\"block-img\"><a ng-href=\"/{{::e.fields.slug}}\" ng-if=\"e.fields.slug == &#39;contact&#39; || e.fields.slug == &#39;about&#39;\"><img class=\"image\" ng-src=\"{{::e.fields.featuredImage.fields.file.url}}\"></a><a ng-href=\"/journal/article/{{::e.fields.slug}}\" ng-if=\"e.fields.slug != &#39;contact&#39; &amp;&amp; e.fields.slug != &#39;about&#39;\"><img class=\"image\" ng-if=\"e.sys.contentType.sys.id != &#39;article&#39;\" ng-src=\"{{::e.fields.featuredImage.fields.file.url}}\"><img class=\"image\" ng-if=\"e.sys.contentType.sys.id == &#39;article&#39;\" ng-src=\"{{::e.fields.heroImages[0].fields.file.url}}\"></a><div class=\"meta journal-post\" ng-class=\"{&#39;getCloser&#39;: !e.fields.date}\"><h4><span class=\"follow-line\" ng-bind-html=\"e.fields.slug | capitalize\" ng-if=\"e.fields.slug == &#39;contact&#39; || e.fields.slug == &#39;about&#39;\"></span><span class=\"follow-line\" ng-if=\"e.fields.slug != &#39;contact&#39; &amp;&amp; e.fields.slug != &#39;about&#39;\">Journal</span><span ng-bind-html=\"::e.fields.date | date: &#39;dd.MM.yy&#39;\"></span></h4></div></div><div class=\"text\"><h2 ng-bind-html=\"::e.fields.title\"></h2><p ng-bind-html=\"::e.fields.excerpt\"></p></div><a class=\"btn\" ng-href=\"/{{::e.fields.slug}}\" ng-if=\"e.fields.slug == &#39;contact&#39; || e.fields.slug == &#39;about&#39;\">Read more</a><span ng-if=\"e.fields.slug != &#39;contact&#39; &amp;&amp; e.fields.slug != &#39;about&#39;\"><a class=\"btn\" ng-href=\"/journal/article/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType != false\">Read more</a><a class=\"btn\" ng-href=\"/journal/gallery/{{::e.fields.slug}}\" ng-if=\"e.fields.articleType == false\">Read more</a></span></article></section></div></div><social></social><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/newsletter.html","<left-col></left-col><div class=\"page static_page\" id=\"menu\"><div class=\"wrapper tiny-wrapper center\"><loading></loading><div ng-if=\"!loading\"><h1 class=\"header-title underline-title\">Join our newsletter</h1><div class=\"contents\"><p>Get all of the latest news and info on articles and our upcoming events</p><newsletter-signup></newsletter-signup></div></div></div></div><social></social><md-footer></md-footer>");
$templateCache.put("templates/views/static_pages/page.html","<left-col></left-col><div class=\"page\" id=\"journal-post\"><article class=\"wrapper small-wrapper\"><loading></loading><div class=\"block\" ng-if=\"!loading\"><div class=\"block-img\"><img class=\"featuredImg\" ng-src=\"{{featuredImage}}?w=1200\"></div><h1 ng-bind-html=\"entry.title\"></h1><div class=\"contents\" markdown-to-html=\"entry.body\"></div></div></article></div><social></social><md-footer></md-footer>");
$templateCache.put("templates/views/shared/footer.html","<footer role=\"contentInfo\"><div class=\"columns twelve\"><div>All rights reserved Content © Hairpin Journal and individual contributors</div><div class=\"links\"><a ng-href=\"/contact\">Contact</a> <a ng-href=\"/advertisers\">Advertisers</a> <a ng-href=\"/contributors\">Contributors</a></div><div><span>Website by</span> <a ng-href=\"https://patio.cool\" target=\"_blank\">Patio</a></div></div></footer>");
$templateCache.put("templates/views/shared/image-modal.html","<div id=\"modal\"><img ng-src=\"{{imageUrl}}?fm=jpg&amp;fl=progressive&amp;w=1200\"></div>");
$templateCache.put("templates/views/shared/left-col.html","<nav class=\"hide-on-mobile\" id=\"left-col\" role=\"banner\"><main-logo></main-logo><ul class=\"navigation\" id=\"primary-nav\"><li><a href=\"/\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;home&#39;}\">Home</a></li><li><a href=\"/journal\" ng-class=\"{&#39;active&#39; : page == &#39;journal&#39; }\">Journal</a></li><li><a href=\"/about\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;about&#39;}\">About</a></li><li><a href=\"/contact\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;contact&#39;}\">Contact</a></li><li><a href=\"/events\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;events&#39;}\">Events</a></li><div class=\"spacer\"></div><li><div class=\"click small\" ng-click=\"showNewsletter()\">Newsletter</div></li></ul><div class=\"bottom-logo\"><div id=\"second-logo\"></div></div></nav><div class=\"show-on-mobile\" id=\"mobile-header\"><div class=\"click\" id=\"close-trigger\" ng-click=\"toggleLeft()\"><i class=\"material-icons\">menu</i></div><main-logo></main-logo></div><md-sidenav class=\"md-sidenav-left md-whiteframe-4dp\" id=\"mobile-menu\" md-component-id=\"left\"><div class=\"click\" id=\"close-trigger\" ng-click=\"close()\"><i class=\"material-icons\">close</i></div><main-logo></main-logo><ul class=\"navigation\"><li><a href=\"/\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;home&#39;}\">Home</a></li><li><a href=\"/journal\" ng-class=\"{&#39;active&#39; : page == &#39;journal&#39; }\">Journal</a></li><li><a href=\"/about\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;about&#39;}\">About</a></li><li><a href=\"/contact\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;contact&#39;}\">Contact</a></li><li><a href=\"/events\" ng-class=\"{&#39;active&#39; : pageUrl == &#39;events&#39;}\">Events</a></li><li><div class=\"click\" ng-click=\"showNewsletter()\">Newsletter</div></li></ul><ul class=\"navigation small-nav\"><li><a ng-href=\"https://www.instagram.com/hairpinjournal/\" target=\"_blank\">Instagram</a></li><li><a ng-href=\"https://www.facebook.com/hairpinjournal/\" target=\"_blank\">Facebook</a></li><li><a ng-href=\"/contact\">Email</a></li></ul></md-sidenav>");
$templateCache.put("templates/views/shared/loading.html","<div class=\"loading\" ng-if=\"loading\"><div class=\"rolling\"></div></div>");
$templateCache.put("templates/views/shared/main-logo.html","<h1><a href=\"/\" id=\"logo\"></a></h1>");
$templateCache.put("templates/views/shared/newsletter-signup.html","<div id=\"newsletter-modal\"><h2>Signup to our newsletter</h2><p>Get our latest stories and event news in your mailbox</p><div id=\"mc_embed_signup\"><form action=\"https://hairpinjournal.us19.list-manage.com/subscribe/post?u=6d5012a09a0dc2efdf6e65429&amp;amp;id=7bd42e230a\" class=\"validate\" id=\"mc-embedded-subscribe-form\" method=\"post\" name=\"mc-embedded-subscribe-form\" novalidate=\"\" target=\"_blank\"><div id=\"mc_embed_signup_scroll\"><div class=\"mc-field-group\"><input class=\"required email\" id=\"mce-EMAIL\" name=\"EMAIL\" placeholder=\"Email address\" type=\"email\" value=\"\"></div><input class=\"button\" id=\"mc-embedded-subscribe\" name=\"subscribe\" type=\"submit\" value=\"Subscribe\"><div class=\"clear\" id=\"mce-responses\"><div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div></div><div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"><input name=\"b_6d5012a09a0dc2efdf6e65429_7bd42e230a\" tabindex=\"-1\" type=\"text\" value=\"\"></div></div></form></div></div>");
$templateCache.put("templates/views/shared/social.html","<div class=\"hide-on-mobile\" id=\"social-block\"><ul><li><a ng-href=\"https://www.instagram.com/hairpinjournal/\" target=\"_blank\">Instagram</a></li><li><a ng-href=\"https://www.facebook.com/hairpinjournal/\" target=\"_blank\">Facebook</a></li><li><a ng-href=\"/contact\">Email</a></li></ul></div>");}]);